import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Style/typo.css";
import "../assets/css/style-helpdesk.css";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Footer from "../../homepage/footer/Footer";

function CloudHelpdesk() {
    const [html, setHtml] = useState("");

    useEffect(() => {
        window.AOS = AOS;

        fetch("https://hanbiro.com/software/fetch-helpdesk.html")
            .then((res) => res.text())
            .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                const baseUrl = "https://hanbiro.com";

                const fixUrl = (url) => {
                    if (url && !url.startsWith("http") && !url.startsWith("//") && !url.startsWith("#") && !url.startsWith("javascript:")) {
                        let cleanUrl = url.startsWith("./") ? url.substring(2) : url;
                        if (cleanUrl.startsWith("asset/image/")) {
                            return `${baseUrl}/assets/images/cloud/${cleanUrl.substring(12)}`;
                        }
                        return cleanUrl.startsWith("/") ? `${baseUrl}${cleanUrl}` : `${baseUrl}/software/${cleanUrl}`;
                    }
                    return url;
                };

                // Fix image paths
                doc.querySelectorAll("img, source").forEach((el) => {
                    const src = el.getAttribute("src");
                    if (src) el.setAttribute("src", fixUrl(src));
                    const srcset = el.getAttribute("srcset");
                    if (srcset) el.setAttribute("srcset", fixUrl(srcset));
                });

                // Fix relative background images in inline styles
                doc.querySelectorAll("[style]").forEach((el) => {
                    const style = el.getAttribute("style");
                    if (style && style.includes("url(")) {
                        const newStyle = style.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                            return `url('${fixUrl(url)}')`;
                        });
                        el.setAttribute("style", newStyle);
                    }
                });

                // Extract and inject styles
                const styles = doc.querySelectorAll("style");
                styles.forEach((oldStyle) => {
                    const newStyle = document.createElement("style");
                    newStyle.className = "fetched-style";
                    let cssContent = oldStyle.innerHTML;
                    // Fix URLs inside CSS
                    cssContent = cssContent.replace(/url\(['"]?([^'"]+)['"]?\)/g, (match, url) => {
                        return `url('${fixUrl(url)}')`;
                    });
                    newStyle.innerHTML = cssContent;
                    document.head.appendChild(newStyle);
                });

                const bodyContent = doc.body.innerHTML;
                setHtml(bodyContent);

                const scripts = doc.querySelectorAll("script");
                scripts.forEach((oldScript) => {
                    if (oldScript.src && oldScript.src.includes("aos")) return;

                    const newScript = document.createElement("script");
                    newScript.className = "fetched-script";
                    Array.from(oldScript.attributes).forEach((attr) =>
                        newScript.setAttribute(attr.name, attr.value)
                    );

                    let content = oldScript.innerHTML;
                    content = content.replace(/AOS\.init\(.*?\);?/g, "");

                    if (content.trim() || oldScript.src) {
                        // Wrap content in block scope to prevent redeclaration errors
                        if (content.trim()) {
                            newScript.appendChild(document.createTextNode(`{ ${content} }`));
                        }
                        document.body.appendChild(newScript);
                    }
                });

                setTimeout(() => {
                    AOS.init({ once: true });
                    AOS.refresh();
                }, 100);
            });

        return () => {
            // Cleanup added styles and scripts
            document.querySelectorAll(".fetched-style, .fetched-script").forEach(el => el.remove());
        };
    }, []);

    return (
        <div>
            <NavButton
                lang="ko"
                option={{
                    logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                    link: "https://hanbiro.com/",
                    color: { backgroundColor: "#7061FF" },
                    itemNavClass: "item-nav nav-pur",
                    menuListProduct: "menu-list-product-item",
                    menuListVora: "vora",
                    menuListGroupware: "groupware",
                    titleTab: "mb-3",
                }}
            />
            <div dangerouslySetInnerHTML={{ __html: html }} />
            <Footer
                option={{
                    textColor: "text-color external-link text-pur-color",
                    textlinkColor: "text-color text-pur-color",
                }}
            />
        </div>
    );
}

export default CloudHelpdesk;
